// extracted by mini-css-extract-plugin
export default {"-large":"xGn3B5XOEKKP8D9ElmRn","block":"qnQtkhoqEd4iN3BGCrlR"};